import { useState, useContext } from 'react';
import { Grid, Typography, Divider, FormControlLabel, Checkbox, Button } from '@mui/material';

import { ILease } from '../../../types/lease';
import { FlexEnd } from '../../../commonStyles';
import Uploads from './Uploads';
import { LeaseContext } from '../../../context/LeaseContext';
import { useAppDispatch } from '../../../app/hooks';
import { showSuccessSnackbar } from '../../../features/snackbar/snackbarSlice';

const KeyHandover = (props: ChildProps) => {
  const storeDispatch = useAppDispatch();
  const { lease } = props;
  const { updateLease } = useContext(LeaseContext);
  const [tenantInsurance, setTenantInsurance] = useState(lease.tenantInsurance ? lease.tenantInsurance : []);
  const [utilitiesSetup, setUtilitiesSetup] = useState(lease.utilitiesSetup ? lease.utilitiesSetup : []);
  const [keyHandover, setKeyHandover] = useState(lease.keyHandover ? lease.keyHandover : []);
  const [payProp, setPayProp] = useState<boolean>(lease.payProp ? lease.payProp : false);

  const handleSave = () => {
    updateLease({
      variables: {
        _id: lease._id,
        record: {
          payProp,
        },
      },
    }).then((res: any) => {
      if (res.data) {
        storeDispatch(showSuccessSnackbar('Lease has been updated!'));
      }
    });
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <FormControlLabel
                style={{
                  marginTop: '10px',
                  marginBottom: '15px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                control={<Checkbox checked={payProp!} onChange={(e) => setPayProp(!payProp)} />}
                label={'Pay Prop Information Sent'}
              />
            </Grid>
          </Grid>
          <FlexEnd>
            <Button onClick={() => handleSave()} variant="contained" color="primary">
              Save
            </Button>
          </FlexEnd>
          <Divider sx={{ my: 2 }} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="h2">Tenant Insurance</Typography>
          <Uploads lease={lease} state={tenantInsurance} setState={setTenantInsurance} type="tenantInsurance" />
          <Divider sx={{ my: 2 }} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="h2">Utilities Setup</Typography>
          <Uploads lease={lease} state={utilitiesSetup} setState={setUtilitiesSetup} type="utilitiesSetup" />
          <Divider sx={{ my: 2 }} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="h2">Key Handover Form</Typography>
          <Uploads lease={lease} state={keyHandover} setState={setKeyHandover} type="keyHandover" />
          <Divider sx={{ my: 2 }} />
        </Grid>
      </Grid>
    </div>
  );
};

interface ChildProps {
  lease: ILease;
}

export default KeyHandover;
